var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RouterView'),_c('div',{staticClass:"container my-5"},[_c('FaqList')],1),_c('div',{staticClass:"container my-5"},[_c('DiscordContact')],1),_c('div',{staticClass:"w-100"},[_c('MGEXFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }